import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivateControlModel, IActivateControlResponseModel } from '@apps-common/types/portal/unit-control'

const activateControl = async (model: IActivateControlModel): Promise<IActivateControlResponseModel> =>
  axios.post(`/my-monitoring/control/ActivateControl`, model).then((res) => ({ message: res?.data?.msg, data: res?.data?.data }))

type Props = {
  model: IActivateControlModel
}

export const useMyMonitoringActivateControl = (
  notify?: boolean,
  onSuccess?: (data: IActivateControlResponseModel, variables: Props['model']) => void,
  onFailure?: ({ model }: Props) => void
) =>
  useMutation({
    mutationKey: ['myMonitoringActivateControl'],
    mutationFn: ({ model }: Props) => activateControl(model),
    onSuccess: (data, variables) => {
      if (onSuccess) {
        onSuccess(data, variables.model)
      }
      if (notify) {
        toastSuccess('Request sent, waiting for update.')
      }
    },
    onError: (error, variables) => {
      if (onFailure) {
        onFailure(variables)
      }
      if (notify) {
        toastError('Failed to send request.')
      }
    },
    throwOnError: false
  })
